module.exports = __webpack_public_path__ + "img/Au-Powerball.c670d989.png";